export function kiloBytesToBytes(kiloBytes: number): number {
    return kiloBytes * Math.pow(2, 10);
}

export function megaBytesToBytes(megaBytes: number): number {
    return megaBytes * Math.pow(2, 20);
}

export function gigaBytesToBytes(gigaBytes: number): number {
    return gigaBytes * Math.pow(2, 30);
}